<template>
  <div :id="'chart_'+uuid">
    <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
      <canvas :id="uuid" :width="size.width" :height="size.height" />
    </div>
  </div>
</template>

<script>
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "ae341200-c00d-11ee-8770-c85acf022408",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      canvas: null,
      graph: null,
      names: [],
      counter: []
    }
  },
  computed: {
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    make_chart: function () {
      this.update_data()
      if (this.canvas) {
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ ChartDataLabels ],
          data: {
            labels: this.names,
            datasets: [{
              label: this.chart_description,
              data: this.counter,
              maxBarThickness: 800
            }]
          },
          options: {
            layout: {
              padding: {
                top: 25
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Кол-во неисправностей'
                },
              }
            },
            plugins: {
              datalabels: {
                anchor: 'end',
                clamp: true,
                align: 'end'
              },
              legend: {
                display: false
              }
            }
          }
        })
      }
    },
    update_data: function () {
      this.names = []
      this.counter = []

      let data = []

      let ids = Object.keys(this.chart.report_data[0])
      ids = ids.filter(name => {
        if (name.includes('_')) return true
      })
      ids.map(name => {
        data[name] = 0
      })
      this.names = ids.map(name => {
        name = name.slice(2)
        name = name.match(/[А-Я]?[а-я]+|[0-9]+|[А-Я]+(?![а-я])/g)
        name = name.map((word, index) => {
          if (index > 0 && typeof word === 'string') {
            return word.toLowerCase()
          } else {
            return word
          }
        })
        return name.join(' ')
      })

      this.chart.report_data.map(element => {
        Object.keys(data).map(field => {
          data[field] += element[field]
        })
      })

      Object.keys(data).map(field => {
        this.counter.push(data[field])
      })
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    }
  },
}
</script>